/* Spanish catalog mirroring locale-inbox-vouchers-fr-part2.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'inbox.inboxWithCount': 'Bandeja de entrada ({count})',
  'inbox.wordDocuments': 'documentos',
  'inbox.wordVouchers': 'justificantes',
  'inbox.emptyDocsTitle': 'Sin documentos',
  'inbox.emptyTrashTitle': 'La papelera está vacía',
  'inbox.emptyDocsText': 'Sube aquí tus acuerdos, contratos y documentos.',
  'inbox.searchDocsFull': 'Buscar documentos - nombre de archivo, tipo...',
  'inbox.vehicleCostReminderDefault': 'Solo si la empresa es propietaria de un vehículo o lo alquila.'
});
